import {
  BatteryCharging,
  Building2,
  Cable,
  Lightbulb,
  ShieldCheck,
  Siren,
  Wifi,
  Zap,
} from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

const services = [
  {
    icon: Zap,
    title: "Socket & Switch Work",
    description:
      "Installation, relocation and repair of electrical sockets and switches throughout your home or business.",
  },
  {
    icon: Cable,
    title: "Wiring & Rewiring",
    description:
      "Full and partial rewires, new wiring installations, ground wire installation and wiring repairs.",
  },
  {
    icon: Lightbulb,
    title: "Lighting Installation & Repair",
    description:
      "Indoor and outdoor light fixture installation and repair, including garden and security lighting.",
  },
  {
    icon: ShieldCheck,
    title: "Electrical Inspections",
    description:
      "EICR testing and electrical inspections for homeowners, landlords and business owners.",
  },
  {
    icon: BatteryCharging,
    title: "EV Charger Installation",
    description:
      "Fast, certified electric car charge point installations for home and workplace.",
  },
  {
    icon: Building2,
    title: "Panel Repair & Upgrade",
    description:
      "Electrical panel repair, full replacement and upgrading, including fuse and heat resistor changes.",
  },
  {
    icon: Siren,
    title: "Alarms & Security Systems",
    description:
      "General alarm installation and full security system installation for peace of mind.",
  },
  {
    icon: Wifi,
    title: "General Repairs & Remodelling",
    description:
      "Fan installation and repair, power restoration, general construction, repairs and remodelling work.",
  },
];

export const Services = () => {
  return (
    <section id="services" className="scroll-mt-20 bg-background py-20">
      <div className="mx-auto max-w-360 px-4 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold tracking-wider text-primary uppercase">
            What We Do
          </span>
          <h2 className="mt-2 text-3xl font-bold sm:text-4xl">
            Electrical Services You Can Rely On
          </h2>
          <p className="mt-4 text-muted-foreground">
            Whatever the size of the job, Andrew and the E.I.M team deliver
            safe, reliable and tidy work across the Fylde Coast, every time.
          </p>
        </div>
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((service) => (
            <Card
              key={service.title}
              className="border-white/10 transition-colors hover:border-primary/50"
            >
              <CardHeader>
                <div className="mb-2 flex size-12 items-center justify-center rounded-lg bg-primary/10">
                  <service.icon className="size-6 text-primary" />
                </div>
                <CardTitle className="text-base">{service.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  {service.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
